import { Grid, GridItem, HStack, Text } from '@chakra-ui/react';
import React from 'react';

import {
  utils as commonUtils,
  finleyAssert,
} from '@finley-technologies/common';

import {
  AssignmentBorrowingBaseReportFragmentGQLType,
  Maybe,
} from 'types/dashboard-core-gqlTypes.generated.d';

import { DollarWithCircleIcon } from './SharedComponents';
import { colors } from 'packages/common-frontend/colors';

export type LeftOnBalanceSheetStatsProps = {
  // meshLabel: string;
  data: {
    // @jendevelops TODO: add back when tagging reason for LoBS
    // | 'excludedViaCriteria' // | 'ineligible'
    // | 'leftOnBalanceSheet'
    [key in 'balanceSheet']: {
      initial: number;
      proposed: number;
    };
  };
};

export const createLeftOnBalanceSheetStatsProps = ({
  // meshLabel,
  initial,
  proposed,
}: {
  // meshLabel: string;
  initial: Maybe<AssignmentBorrowingBaseReportFragmentGQLType>;
  proposed: Maybe<AssignmentBorrowingBaseReportFragmentGQLType>;
}): LeftOnBalanceSheetStatsProps => {
  finleyAssert(
    initial && proposed,
    'Expected initial and proposed assignment borrowing base previews to exist',
  );
  return {
    // meshLabel,
    data: {
      balanceSheet: {
        initial: initial.balanceSheetExposure,
        proposed: proposed.balanceSheetExposure,
      },
    },
  };
};

const StatRow: React.FC<{
  label: React.ReactNode;
  initial: React.ReactNode;
  proposed: React.ReactNode;
  highlightProposed?: boolean;
}> = ({ label, initial, proposed, highlightProposed = false }) => (
  <>
    <GridItem colSpan={2} p="16px">
      {label}
    </GridItem>
    <GridItem colSpan={1} p="16px" display="flex">
      {initial}
    </GridItem>
    <GridItem
      colSpan={1}
      p="16px"
      bg={highlightProposed ? colors.aurora[50] : undefined}
      display="flex"
    >
      {proposed}
    </GridItem>
  </>
);

export const LeftOnBalanceSheetStats: React.FC<LeftOnBalanceSheetStatsProps> = ({
  // meshLabel,
  data: {
    balanceSheet,
    // @jendevelops TODO: add back when tagging reason for LoBS
    // ineligible, excludedViaCriteria, leftOnBalanceSheet
  },
}) => {
  return (
    // @jendevelops TODO: add back when tagging reason for LoBS
    // <Grid templateColumns="repeat(4, 1fr)" templateRows="repeat(4, 80px)">
    <Grid
      templateColumns="repeat(4, 1fr)"
      borderBottom="1px solid"
      borderColor={colors.gray[200]}
    >
      <StatRow
        highlightProposed
        label={
          <HStack>
            <DollarWithCircleIcon mr="16px" />
            <Text fontSize="larger" fontWeight="semibold">
              Balance Sheet
            </Text>
            {/* @jendevelops TODO: add back in when move to multi mesh */}
            {/* <Tooltip
              color="black"
              label={`Balance Sheet figures only reflect recievables assigned to ${meshLabel}`}
            >
              <InfoIcon color="blue" />
            </Tooltip> */}
          </HStack>
        }
        initial={
          <Text
            alignSelf="center"
            fontWeight="medium"
          >{`$${commonUtils.numberWithCommasAndDecimals(
            balanceSheet.initial,
          )}`}</Text>
        }
        proposed={
          <Text alignSelf="center" fontWeight="medium">
            {`$${commonUtils.numberWithCommasAndDecimals(
              balanceSheet.proposed,
            )}`}
          </Text>
        }
      />
      {/* <StatRow
        highlightProposed
        label={<Text>Ineligible</Text>}
        initial={
          <Text>{`$ ${commonUtils.numberWithCommasAndDecimals(
            ineligible.initial,
          )}`}</Text>
        }
        proposed={
          <Text>
            {`$ ${commonUtils.numberWithCommasAndDecimals(
              ineligible.proposed,
            )}`}
          </Text>
        }
      />
      <StatRow
        highlightProposed
        label={<Text>Excluded via Criteria</Text>}
        initial={
          <Text>{`$ ${commonUtils.numberWithCommasAndDecimals(
            excludedViaCriteria.initial,
          )}`}</Text>
        }
        proposed={
          <Text>
            {`$ ${commonUtils.numberWithCommasAndDecimals(
              excludedViaCriteria.proposed,
            )}`}
          </Text>
        }
      />
      <StatRow
        highlightProposed
        label={<Text>Left on Balance Sheet</Text>}
        initial={
          <Text>{`$ ${commonUtils.numberWithCommasAndDecimals(
            leftOnBalanceSheet.initial,
          )}`}</Text>
        }
        proposed={
          <Text>
            {`$ ${commonUtils.numberWithCommasAndDecimals(
              leftOnBalanceSheet.proposed,
            )}`}
          </Text>
        }
      /> */}
    </Grid>
  );
};
